import {useTranslation} from "react-i18next";
import {useMemo} from "react";
import {yup} from "./index";


export const usePersonCaughtSchema = () => {
    const {t} = useTranslation('validation');

    const number = yup.number().emptyToNull().typeError(t('validation:number'))
    const positiveInteger = number.integer(t('validation:integer')).min(0, t('validation:gte', {gte: 0}))

    return useMemo(
        () => (
            yup.object().shape({
                severity: yup.string().required(t('validation:required')),
                // required when severity is 3
                deathType: yup.string().when('severity', {
                    is: (severity) => severity === '3',
                    then: (schema) => schema.required(t('validation:required')),
                    otherwise: (schema) => schema.notRequired(),
                }),

                burialScale: yup.string().required(t('validation:required')),
                ageRange: yup.string().required(t('validation:required')),
                age: positiveInteger,
                sex: yup.string().required(t('validation:required')),
                nationality: yup.string().required(t('validation:required')),
                local: yup.boolean().required(t('validation:required')),
                caughtWhileWorking: yup.boolean().required(t('validation:required')),
                equipments: yup.array().of(
                    yup.object().shape({
                        code: yup.string().required(t('validation:required')),
                    })
                ),
                equipmentOther: yup.string().nullable(),
                jobTitles: yup.array().of(
                    yup.object().shape({
                        code: yup.string().required(t('validation:required')),
                    })
                ),
                jobTitleOther: yup.string().nullable(),
                rescueType: yup.string().required(t('validation:required')),
                searchMethod: yup.string().nullable(),
                searchMethodOther: yup.string().nullable(),
                burialDepth: yup.string().when('burialScale', {
                    is: (burialScale) => burialScale === '1' || burialScale === '2' || burialScale === '3',
                    then: (schema) => schema.required(t('validation:required')),
                    otherwise: (schema) => schema,
                }).when('burialScale', {
                    is: (burialScale) => burialScale === '4',
                    then: (schema) => schema.nullable().test('is-null', t('validation:null'), (value) => value === null || value === '' || value === undefined),
                    otherwise: (schema) => schema,
                }),
            }))
        ,
        [t]
    )
}